import { GridController, gridTpl } from '../../../../common/grid/grid.controller';
import { IDS } from '../audit-action-id.constants';
import * as Actions from '../audit.actions';

class RcoAuditRequirementsGridController extends GridController {
    constructor($ngRedux, $state, NavigationService, $filter, $mdDialog, $scope) {
        super($ngRedux, $state, NavigationService, $filter, $mdDialog);
        this.$scope = $scope;
    }

    $onInit() {
        this.module = 'accreditation';
        this.identifier = IDS.accAudit;
        this.statePath = IDS.addAuditRequirementsGrid;
        this.filterComponent = false;
        this.exportComponent = false;
        // this.confirmDialogOnRemove = true;
        this.autoload = false;
        this.icon = false;

        this.columns = [
            {title: 'Requirement',          mapper: 'name'},
            {title: 'Evidence Responsible', mapper: 'evidence_owner_name'},
            {title: 'Evidence Due Date',    mapper: 'evidence_due_date', type: 'date'},
            {title: 'Audit Due Date',       mapper: 'audit_due_date', type: 'date'},
        ];

        this.unsubscribe = this.$ngRedux.connect(this.mapState().bind(this), Actions)(this);

        this.init();
    }

    $onDestroy() {
        this.destroy();
    }
}

RcoAuditRequirementsGridController.$inject = ['$ngRedux', '$state', 'NavigationService', '$filter', '$mdDialog', '$scope'];

export const rcoAuditRequirementsGrid = {
    bindings: {
        title: '@',
        onRemove: '&',
    },
    controller: RcoAuditRequirementsGridController,
    ...gridTpl
}
